import { translations } from './translations';

export class LanguageService {
    constructor() {
        this.currentLanguage = localStorage.getItem('language') || 'en';
        this.listeners = new Set();
        this.isUpdating = false;
    }

    setLanguage(language) {
        if (this.currentLanguage === language) return;
        
        this.currentLanguage = language;
        localStorage.setItem('language', language);
        this.updatePageContent();
        this.notifyListeners();
    }

    getTranslation(key) {
        return translations[this.currentLanguage]?.[key] || key;
    }

    updatePageContent() {
        if (this.isUpdating) return;
        this.isUpdating = true;

        try {
            // Update elements with data-i18n attribute
            const elements = document.querySelectorAll('[data-i18n]');
            elements.forEach(element => {
                const key = element.getAttribute('data-i18n');
                if (key) {
                    const translation = this.getTranslation(key);
                    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
                        element.placeholder = translation;
                    } else {
                        element.textContent = translation;
                    }
                }
            });

            // Update elements with data-i18n-attr attribute
            const attrElements = document.querySelectorAll('[data-i18n-attr]');
            attrElements.forEach(element => {
                const attrData = element.getAttribute('data-i18n-attr');
                if (attrData) {
                    const [attr, key] = attrData.split(':');
                    if (attr && key) {
                        const translation = this.getTranslation(key);
                        element.setAttribute(attr, translation);
                    }
                }
            });

            // Update elements with data-i18n-title attribute
            const titleElements = document.querySelectorAll('[data-i18n-title]');
            titleElements.forEach(element => {
                const key = element.getAttribute('data-i18n-title');
                if (key) {
                    const translation = this.getTranslation(key);
                    element.title = translation;
                }
            });

            // Update elements with data-i18n-alt attribute
            const altElements = document.querySelectorAll('[data-i18n-alt]');
            altElements.forEach(element => {
                const key = element.getAttribute('data-i18n-alt');
                if (key) {
                    const translation = this.getTranslation(key);
                    element.alt = translation;
                }
            });

            // Dispatch a custom event to notify components
            const event = new CustomEvent('languageChanged', {
                detail: { language: this.currentLanguage }
            });
            document.dispatchEvent(event);
        } catch (error) {
            console.error('Error updating page content:', error);
        } finally {
            this.isUpdating = false;
        }
    }

    getCurrentLanguage() {
        return this.currentLanguage;
    }

    addListener(listener) {
        this.listeners.add(listener);
    }

    removeListener(listener) {
        this.listeners.delete(listener);
    }

    notifyListeners() {
        this.listeners.forEach(listener => listener(this.currentLanguage));
    }
}

export const languageService = new LanguageService(); 